import React, { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { mobileNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
import { ButtonLink } from '../ui/ButtonLink';
interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
}
export function MobileNavDrawer({
  open,
  onClose
}: MobileNavDrawerProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-369" data-mp="2iza594hcrs18">
      {open && <div className="fixed inset-0 z-[60] xl:hidden" role="dialog" aria-modal="true" aria-label="Site navigation" data-id="element-370" data-mp="2iy8vd3c2pbl3">
          <motion.div className="absolute inset-0 bg-plum/60" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-371" data-mp="2dznqurpsg5qu" />
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.32, 0.72, 0, 1]
      }} className="on-dark absolute right-0 top-0 flex h-full w-full max-w-sm flex-col bg-aubergine text-porcelain" data-id="element-372" data-mp="207zi8yeqzzem">
            <div className="flex h-20 items-center justify-between px-6" data-id="element-373" data-mp="2573slsdes36j">
              <Logo tone="light" data-id="element-374" data-mp="1hhhpwuxtv5ts" />
              <button ref={closeRef} type="button" onClick={onClose} className="flex h-10 w-10 items-center justify-center rounded-full text-porcelain/80 hover:bg-porcelain/10 hover:text-porcelain" aria-label="Close menu" data-id="element-375" data-mp="1hggfmsomynd4">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-376" data-mp="266kq4osjcdly" />
              </button>
            </div>
            <nav aria-label="Mobile" className="flex-1 overflow-y-auto px-6 pb-6" data-id="element-377" data-mp="2b2037eipy5hb">
              <ul className="border-t border-porcelain/10" data-id="element-378" data-mp="2fxyzrpe7atst">
                {mobileNav.map(item => <li key={item.to} className="border-b border-porcelain/10" data-id="element-379" data-mp="1jakk3ugdf0vu">
                    <NavLink to={item.to} end={item.to === '/'} onClick={onClose} className={({
                isActive
              }) => `flex items-center justify-between py-4 font-display text-lg font-medium transition-colors duration-150 ${isActive ? 'text-copper-light' : 'text-porcelain/85 hover:text-porcelain'}`} data-id="element-380" data-mp="1nal55xxz6abv">
                      {({
                  isActive
                }) => <>
                          {item.label}
                          {isActive && <span className="h-1.5 w-1.5 rounded-full bg-copper-light" aria-hidden="true" data-id="element-381" data-mp="s3by0ktqpkyq" />}
                        </>}
                    </NavLink>
                  </li>)}
              </ul>
            </nav>
            <div className="border-t border-porcelain/10 p-6" data-id="element-382" data-mp="eackuphfk2uc">
              <ButtonLink to="/employers#inquiry" className="w-full" data-id="element-383" data-mp="99yldvtwa17x">
                Partner With Us
              </ButtonLink>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}